import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Every page renders its own <Header />, so keep the banner at module level:
// it is fetched once per page load and shown instantly when navigating between pages.
let cachedBanner = null;
let inflight = null;

function fetchBanner() {
  if (!inflight) {
    inflight = axios
      .get(`${API}/site-banner`)
      .then((res) => {
        cachedBanner = res.data;
        return cachedBanner;
      })
      .catch(() => null) // if the API is unreachable, simply show no banner
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** Call after saving in the admin so the next render re-reads the banner. */
export function clearSiteBannerCache() {
  cachedBanner = null;
}

/** Banner shown at the top of the public site: { is_enabled, message, link_text, link_url } or null. */
export default function useSiteBanner() {
  const [banner, setBanner] = useState(cachedBanner);

  useEffect(() => {
    if (cachedBanner) return undefined;
    let cancelled = false;
    fetchBanner().then((data) => {
      if (!cancelled && data) setBanner(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return banner;
}
